export { default } from './ReCaptchaV2';
